import { Component, NgZone } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

/**
 * Toast style Bootstrap (header + body), variante succès / erreur / info / warning.
 * Durée globale : 1 minute (config ToastrModule).
 */
@Component({
  selector: 'app-bootstrap-toast',
  templateUrl: './bootstrap-toast.component.html',
  styleUrls: ['./bootstrap-toast.component.scss'],
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0, transform: 'translateY(12px)' })),
      state('active', style({ opacity: 1, transform: 'translateY(0)' })),
      state('removed', style({ opacity: 0, transform: 'translateY(8px)' })),
      transition(
        'inactive => active',
        animate('{{ easeTime }}ms {{ easing }}')
      ),
      transition(
        'active => removed',
        animate('{{ easeTime }}ms {{ easing }}')
      ),
    ]),
  ],
  preserveWhitespaces: false,
})
export class BootstrapToastComponent extends Toast {
  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    protected ngZone?: NgZone
  ) {
    super(toastrService, toastPackage, ngZone);
  }

  get toastKind(): 'success' | 'error' | 'info' | 'warning' | 'default' {
    const t = String(this.toastPackage.toastType || '');
    if (t.includes('success')) return 'success';
    if (t.includes('error')) return 'error';
    if (t.includes('warning')) return 'warning';
    if (t.includes('info')) return 'info';
    return 'default';
  }

  get displayTitle(): string {
    const t = (this.title || '').trim();
    if (t) return t;
    switch (this.toastKind) {
      case 'success':
        return 'Succès';
      case 'error':
        return 'Erreur';
      case 'warning':
        return 'Attention';
      case 'info':
        return 'Info';
      default:
        return 'Notification';
    }
  }

  /** Libellé type Bootstrap « 11 mins ago » — durée toast = 1 min. */
  get timeLabel(): string {
    return '1 min';
  }

  action(event: Event): void {
    event.stopPropagation();
    this.toastPackage.triggerAction();
    this.remove();
  }
}
